import {
  Component, OnInit, Renderer2, ElementRef,
  Input, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { SearchModel } from 'shared/search/search.model';
import { StatusModel } from 'shared/search/status.model';
import { APPROVED } from 'shared/receivers/receivers-statuses-id';
import { statusLookup } from 'shared/receivers/receivers-statuses';

import { DashboardSearchService } from './dashboard-search.service';
import { DashboardSearchComponent } from './base/dashboard-search.component';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search-receivers-my',
  templateUrl: './base/dashboard-search.component.html',
  styleUrls: ['./base/dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchReceiversMyComponent extends DashboardSearchComponent {

  name: string = 'receivers-my';
  text: string = 'My receivers';
  count: number = 0;
  statusId: number = APPROVED; // MY RECEIVERS

  @Input() invalid: boolean = false;

  constructor(
    protected brandService: BrandService,
    protected permissionsService: PermissionsService,
    protected searchService: DashboardSearchService,
    protected router: Router,
    protected _renderer: Renderer2,
    protected ref: ChangeDetectorRef,
    public elementRef: ElementRef,
  ) {
    super(
      brandService,
      permissionsService,
      searchService,
      router,
      _renderer,
      ref,
      elementRef,
    );
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/
  get link(): string {
    return '/receivers/my';
  }

  get isAllowedLink() {
    return this.hasPermission(['catalog-edit', 'admin', 'repository']);
  }

  /*******************************************
   * COMPONENT PROTECTED METHODS
   *******************************************/

  protected initSearchModel() {
    this.searchModel = new SearchModel();
    this.searchModel.route = 'my';
    this.searchModel.itemsPerPage = 1;
    this.searchModel.statusModel = new StatusModel();
    this.searchModel.statusModel.id = this.statusId;
  }

  protected setData(data: any) {
    this.count = _.get(data, 'total', '--');
    this.updateStatusModel(data);
  }

  // redefine parent method
  protected updateStatusModel(data: any) {
    if (data.statuses) {
      const status = _.find(data.statuses, {id: this.statusId});
      if (status) {
        // @ts-ignore
          this.searchModel.statusModel = status;
        this.searchModel.statusModel.name = _.get(_.find(statusLookup, ['id', this.statusId]), 'status', '');
      }
    }
  }
}
